import { useState } from "react";
import { Clock } from "lucide-react";

import { useGetIdentity, useTranslate } from "ra-core";

import { Card } from "@/components/ui/card";

import { useIsMobile } from "@/hooks/use-mobile";

import { ActivityLog } from "../activity/ActivityLog";

export function DashboardActivityLog() {
  const { identity } = useGetIdentity();
  const scope = identity?.administrator ? "all" : "mine";
  const isMobile = useIsMobile();

  const translate = useTranslate();

  const [controlsHost, setControlsHost] = useState<HTMLDivElement | null>(null);

  return (
    <div className="flex flex-col">
      <div className="mb-3 flex items-center gap-2 md:mb-2">
        <div data-mobile-decoration className="flex shrink-0">
          <Clock className="size-4 md:size-6 text-muted-foreground" />
        </div>

        <h2 className="min-w-0 flex-1 text-base md:text-xl font-semibold text-muted-foreground">
          {translate("crm.dashboard.latest_activity", {
            _: "Последняя активность",
          })}
        </h2>
        <div ref={setControlsHost} className="shrink-0" />
      </div>

      {isMobile ? (
        <ActivityLog
          pageSize={10}
          showTypeFilters
          controlsContainer={controlsHost}
          scope={scope}
        />
      ) : (
        <Card className="relative mb-2 p-6">
          <ActivityLog
            pageSize={10}
            showTypeFilters
            controlsContainer={controlsHost}
            scope={scope}
          />
        </Card>
      )}
    </div>
  );
}
